<template>
  <div>
    <ul :class="$style['list']">
      <li v-if="state === 'ACTIVATE' || state === 'HAS_PORTAL'"><router-link :to="toUrl">Activate portal</router-link></li>
      <li v-else>
        <div>Unable to activate.</div>
        <div v-if="contactCount === 0">Customer has no Contacts.</div>
      </li>
    </ul>
  </div>
</template>

<script>

  const buttonStates = {
    ACTIVATE: "ACTIVATE",
    HAS_PORTAL: "HAS_PORTAL",
    ERROR: "ERROR"
  }

  export default {

    data() {
      return {}
    },

    props: {
      customerId: {
        type: String,
        required: true
      },

      contactCount: {
        type: Number
      },

      returnShopPortal: {
        type: Object
      }
    },

    computed: {
      state() {
        if(!this.contactCount) {
          return buttonStates.ERROR
        } else if(!this.returnShopPortal) {
          return buttonStates.ACTIVATE
        }

        return buttonStates.HAS_PORTAL
      },

      toUrl() {
        return `/returnshopportals/activate/${this.customerId}`
      }
    }
  }
</script>

<style module>
  .list {
    padding-left: 0;
    list-style-type: none;
  }
</style>



// WEBPACK FOOTER //
// IsrsActiveOrOpenPortalBtn.vue?a7056d5c